import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const sendFile = createAsyncThunk(
  "uploadHojaDeCargo",
  async (data: any[], { rejectWithValue }) => {
    const fileToUpload: any = data[0];
    const idHojaCargo: any = data[1];

    if (fileToUpload.length > 0) {
      const formData = new FormData();
      formData.append("image", fileToUpload[0]);
      const { data: dataResponse } = await axiosInstance.post(
        `${api.hojasDeCargoURL}hojacargo/uploadMobile?hc=${idHojaCargo}`,
        formData
      );
    }
    return Response;
  }
);
